import { showDialog } from "vant";
export default {
  name: "OrderQuery",
  data() {
    return {
      adOrder: {},
      adOrders: null,
      show: false
    };
  },
  methods: {
    queryOrder() {
      this.adOrders = null;
      let url = "/ad-server/specialorder/query";
      this.$axios.post(url, this.adOrder).then(resp => {
        // this.show = true;
        if (resp.data.status == this.SUCCESS) {
          this.adOrders = resp.data.list;
        } else {
          showDialog({
            message: resp.data.message
          });
        }
      });
    }
  }
};